import React from "react";

import { View, StyleSheet, Text } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  checkboxGroup: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  checkbox: {
    backgroundColor: "#f8f9fb",
    height: "4mm",
    width: "4mm",
    border: "1pt solid #E5E9F0",
    borderRadius: "2pt",
  },
  checkboxLabel: {
    paddingLeft: "2mm",
    color: "#2E3440",
  },
});

type CheckboxProps = {
  label: string;
};

const Checkbox: React.FC<CheckboxProps> = ({ label }) => (
  <View style={styles.checkboxGroup}>
    <View style={styles.checkbox} />
    <Text style={styles.checkboxLabel}>{label}</Text>
  </View>
);

export default Checkbox;
